<template>
<div>
      <div class="container">
        <div class="container-diam">
            <div class="title-box webCSS">
                <span class="title_1">GIA裸钻查询</span>
            </div>
            <div class="DiamondList-main" :onScrollTop="'100px'" :onScrollBackgroundColor="'#fff'" :onAreMore="hasMore" :onRefreshDelay="options.refreshDelay" @bindPullDown="onPullDown" slot="container">
            <div class="diamondList-info-box" v-if="dataList.length">
                <div class="diamondList-info" v-for="(item, index) in dataList" :key="index" @click="showDetail(item)">
                    <div class="diamondList-info-img">
                        <img v-if="item.fullPath" :src="item.fullPath" class="image-full">
                        <p v-if="uid == 19" class="diamond-los">{{item.los == 1 ? '现货' : item.los == 2 ? '订货' : ''}}</p>
                    </div>
                    <div class="diamondList-info-item clearfix">
                        形状：{{item.cnShape || '-'}}　重量：{{item.d_size || '-'}}ct　颜色：{{item.color || '-'}}
                    </div>
                    <div class="diamondList-info-item clearfix">
                        净度：{{item.clarity || '-'}}　荧光：{{item.flour || '-'}}
                    </div>
                    <div class="diamondList-info-item clearfix">
                        切工：{{item.cut || '-'}}　抛光：{{item.polish || '-'}}　对称：{{item.sym || '-'}}
                    </div>
                    <div class="diamondList-info-price">¥ {{item.price}}</div>
                    <div class="diamondList-info-btn">查看详情</div>
                </div>
            </div>
            <div class="list-none" v-if="!dataList.length && options.isOk">暂无符合的数据</div>
        </div>
        <DiamondDetail :visible="options.DiamondDetail" :item="database.selectItem" slot="headerExtend" @onComplete="onDiamondDetail"></DiamondDetail>
            <div class="clear">
            </div>
        </div>
    </div>
    </div>
</template>
<script>
    import Core from '@/until/core'
    import ScrollPullDown from '@/public/ScrollPullDown'
    import DiamondDetail from '@/public/DiamondDetail'
    import SideMenu from '@/public/SideMenu'
    import _ from 'lodash'
    export default {
        name: 'DiamondList',
        data () {
            return {
                options: {
                    isOk: false,
                    refreshDelay: 0,
                    DiamondDetail: false,
                    SideMenu: false
                },
                database: {
                    paging: {
                        uid: 9,
                        order_name: 'price',
                        order_type: 'ASC',
                        pagesize: 10,
                        pageint: 1,
                        totalrecord: 0,
                        totalpage: 0
                    },
                    list: [],
                    selectItem: {}
                }
            }
        },
        components: {
            ScrollPullDown,
            DiamondDetail,
            SideMenu
        },
        watch: {},
        computed: {
            diamSearch () {
                return this.$store.state.diamSearch
            },
            hasMore () {
                return this.database.paging.totalpage > this.database.paging.pageint
            },
            dataList () {
                const data = this.database.list || []
                const shape = ['ROUND', 'PRINCESS', 'PEAR', 'HEART', 'MARQUISE', 'OVAL', 'EMERALD', 'RADIANT', 'CUSHION', 'TRIANGLE']
                for (let value of data) {
                    if (value.shape && shape.indexOf(value.shape) > -1) {
                        value.fullPath = '/static/img/' + value.shape.toLowerCase() + '.png'
                    }
                    if (!value.fullPath) {
                        value.fullPath = '/static/img/other.png'
                    }
                    value.price = parseInt(value.cny_price, 10) || 0
                }
                return data
            },
            uid () {
                return this.$route.params.Uid
            }
        },
        filters: {},
        methods: {
            goPage (name, bool) {
                const that = this
                if (bool) {
                    return Core.goNext(name, that.$route.params)
                }
                Core.loginExist().then(res => {
                    if (res) {
                        return Core.goNext(name, that.$route.params)
                    }
                    Core.goNext('StaffLogin', that.$route.params)
                })
            },
            loginOut () {
                        Core.onRemoveToken()
                        Core.goNext('StaffLogin', this.$route.params, true)
                    },
            onDiamondDetail (state) {
                this.options.DiamondDetail = false
                if (state === 'car') {
                    this.pushCar()
                } else if (state === 'order') {
                    this.createOrder()
                }
            },
            onGetList () {
                const that = this
                const param = Object.assign({}, that.database.paging, that.diamSearch)
                that.$store.commit('onChangeAppLoaderShow', true)
                Core('Custommall/Diamond/Stafflists', param).then(result => {
                    that.options.refreshDelay += 1
                    that.$store.commit('onChangeAppLoaderShow', false)
                    that.options.isOk = true
                    const res = result.data || {}
                    if (res.error_code || !res.data) {
                        return layer.msg(res.error_msg || '系统繁忙', {icon: 0})
                    }
                    that.database.paging.totalrecord = parseInt(res.data.totalrecord || 0, 10)
                    that.database.paging.totalpage = parseInt(res.data.totalpage || 0, 10)
                    that.database.list = _.concat([], that.database.list, res.data.list)
                })
            },
            onPullDown (done) {
                const that = this
                // 下拉加载
                if (!this.hasMore) {
                    return layer.msg('已经是最后一页了！')
                }
                if (that.database.paging.totalpage > that.database.paging.pageint) {
                    that.database.paging.pageint += 1
                    that.onGetList()
                }
                setTimeout(done, 2000)
            },
            showDetail (item) {
                this.database.selectItem = item
                this.options.DiamondDetail = true
            },
            onSideMenu (state) {
                this.options.SideMenu = false
            },
            goBack () {
                Core.goBack()
            },
            pushCar (done) {
                const that = this
                const param = {}
                param.database = {}
                param.database.diamond_id = that.database.selectItem.id
                param.database.cart_product_number = 1
                that.$store.commit('onChangeAppLoaderShow', true)
                Core('Custommall/Cart/DiamondChange', param).then(result => {
                    const res = result.data || {}
                    if (res.error_code || !res.data) {
                        that.$store.commit('onChangeAppLoaderShow', false)
                        return layer.msg(res.error_msg || '系统繁忙', {icon: 0})
                    }
                    if (done && typeof done === 'function') {
                        return done(res)
                    }
                    that.$store.commit('onChangeAppLoaderShow', false)
                    layer.msg('加入购物车成功！', {icon: 1})
                })
            },
            createOrder () {
                const that = this
                that.pushCar((car) => {
                    const param = {}
                    param.cart_id = []
                    param.cart_id.push(car.data.cart_id)
                    that.$store.commit('onChangeAppLoaderShow', true)
                    Core('Custommall/Order/DiamondCartCreate', param).then(result => {
                        that.$store.commit('onChangeAppLoaderShow', false)
                        const res = result.data || {}
                        if (res.error_code || !res.data) {
                            return layer.msg(res.error_msg || '系统繁忙', {icon: 0})
                        }
                        layer.msg('下单成功！', {icon: 1})
                        Core.goNext('MyOrder', that.$route.params)
                    })
                })
            }
        },
        mounted () {
            console.log(this.database.selectItem)
            const that = this
            that.database.paging.uid = that.$route.params.Uid
            that.onGetList()
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../../node_modules/swiper/dist/css/swiper.min.css';
@import '../../static/css/yellow.css';
@import '../../static/css/font-awesome.css';
@import '../../static/css/default.css';
.Home-banner{ width: 100%; height: 600px;  background-color: #fff; }
.btn-hk {
            color: #fff;
            padding: 8px 16px;
            line-height: 100px;
            background: #F268A3;
            border-radius: 2px;
            font-size: 13px;
        }

        .modelBox {
            position: fixed;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            background: rgba(0, 0, 0, .65);
            z-index: 999;
        }

        .model {
            position: absolute;
            width: 1000px;
            height: 500px;
            margin: 0 auto;
            left: 0;
            right: 0;
            top: calc(50% - 350px);
            z-index: 9999;
            text-align: center;
            padding: 50px 0;
        }

        .closed {
            display: block;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            position: absolute;
            right: 150px;
            top: 120px;
            text-align: center;
            line-height: 22px;
            background: #e0b12f;
            color: #fff;
            font-size: 14px;
            cursor: pointer;

        }

        .timeer {
            text-align: center;
            position: absolute;
            bottom: 0;
            width: 100px;
            margin: auto;
            left: 0;
            right: 0;
            line-height: 40px;
            font-size: 14px;
            color: #FFEB3B;
            font-size: 18px;
            border-radius: 5px;
        }
        .nav{ height: 90px; }
        .header-ce{ width:1000px; }
        .header-ce ul li{ float: left; line-height: 90px; width:100px; text-align: center;}
    .DiamondList-main{ width: 100%; padding: 30px 26px 1px; height: 600px; overflow: auto; }
    .diamondList-info{ width: 100%; height: 200px; padding-left: 220px; position: relative; margin-bottom: 30px; }
    .diamondList-info-img{ position: absolute; left: 0; top: 0; width: 200px; height: 100%; border-radius: 10px; overflow: hidden; background-color: #fbfbfb; }
    .diamondList-info-item{ width: 100%; height:26px; line-height:26px; font-size: 18px; }
    .diamondList-info-item-info{ float: left; width: 33.333%; height: 100%; overflow: hidden; }
    .diamondList-info-item-info.left{ padding-left: 20px; }
    .diamondList-info-item-info.full{ width: 100%; }
    .diamondList-info-item-info.half{ width: 50%; }
    .diamondList-info-price{ position: absolute; left: 220px; bottom: 0; line-height: 170px; font-size: 26px; color: #ff410f; }
    .diamondList-info-btn{ position: absolute; right: 0; bottom: 0; height: 50px; line-height: 46px; padding: 0 20px; border: 1px solid #ff410f; color: #ff410f; font-size: 26px; border-radius: 25px; }
    .diamondList-info-box{ width: 100%; }
</style>



// WEBPACK FOOTER //
// src/components/DiamondList.vue